"use client";

import styles from "./ResetPasswordPageContainer.module.scss";
import { ReactNode } from "react";

/**
 * ResetPasswordPageContainer Component
 *
 * Wrapper component for main reset password content area.
 * Provides styling and layout structure for reset password form and header.
 */
export const ResetPasswordPageContainer = ({
  children,
}: {
  children: ReactNode;
}) => {
  return <div className={styles["comp"]}>{children}</div>;
};
